<template>
  <span>
  {{sizeWatcher}}
    <q-btn-dropdown class="loginButton" dropdown-icon="none" stretch flat label="Login" :icon="icon" v-if="!loggedIn" >
      <q-item>
        <q-item-section>
          <login-open class="loginOpen" v-model="details" />
          <q-btn text-color="primary" to="/register-retail" class="full-width q-mx-md">Register</q-btn >
        </q-item-section>
      </q-item>
    </q-btn-dropdown>
    <q-btn-dropdown class="accountButton" stretch flat dense :label="accountLabel" icon="person" v-if="loggedIn">
      <q-item>
        <q-item-section>
          <div  class="detailsBox" v-if="loggedIn">
           <div class="text-center name">{{ getName() }}</div>
           <div class="text-center email">{{ getEmail() }}</div>
          </div>
        </q-item-section>
      </q-item>
      <q-separator inset spaced></q-separator>
      <q-item @click="cleanFilter" to="/retail" :style="activeRetailStyle" v-if="setActiveStoreStyle">
        <q-item-section avatar>
          <q-icon name="store" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Retail Store</q-item-label>
        </q-item-section>
      </q-item>
      <q-item  @click="cleanFilter" to="/stock" v-if="currentAccount.roles.includes('stockStoreAccess') && setActiveStoreStyle" :style="activeStockStyle">
        <q-item-section avatar>
          <q-icon name="shopping_basket" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Stock Store</q-item-label>
        </q-item-section>
      </q-item>
      <q-item  @click="cleanFilter" to="/container" v-if=" currentAccount.roles.includes('containerStoreAccess') && setActiveStoreStyle" :style="activeContainerStyle">
        <q-item-section avatar>
          <!-- <img style="width: 18px; height: 18px; margin-left: 3px" src="../../assets/factory.svg" /> -->
          <q-icon name="home_work" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Factory Store</q-item-label>
        </q-item-section>
      </q-item>
      <q-item to="/account/details" v-if="currentAccount.roles.includes('stockStoreAccess')" >
        <q-item-section avatar>
          <q-icon name="info" />
        </q-item-section>
        <q-item-section>
          <q-item-label>My Details</q-item-label>
        </q-item-section>
      </q-item>
      <q-item to="/account/details-retail" v-if="currentAccount.roles.includes('retailStoreAccess')" >
        <q-item-section avatar>
          <q-icon name="info" />
        </q-item-section>
        <q-item-section>
          <q-item-label>My Details</q-item-label>
        </q-item-section>
      </q-item>
      <q-item to="/account/orders">
        <q-item-section avatar>
          <q-icon name="layers" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Order History</q-item-label>
        </q-item-section>
      </q-item>
      <q-item to="/account/favourite-colours">
        <q-item-section avatar>
          <q-icon name="palette" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Favourite Colours</q-item-label>
        </q-item-section>
      </q-item>
      <q-expansion-item :content-inset-level="0.25" icon="shopping_cart" label="Manage Carts" >
        <q-item v-if="currentAccount.roles.includes('retailStoreAccess')">
          <q-item-section avatar>
            <q-icon name="shopping_cart" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Retail Carts</q-item-label>
          </q-item-section>
          <q-item-section side>
            <q-btn class="q-px-none" icon="more_horiz" flat dense>
              <edit-cart-menu store-type="retail" />
            </q-btn>
          </q-item-section>
        </q-item>
        <q-item v-if="currentAccount.roles.includes('stockStoreAccess')">
          <q-item-section avatar>
            <q-icon name="shopping_cart" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Stock Carts</q-item-label>
          </q-item-section>
          <q-item-section side>
            <q-btn class="q-px-none" icon="more_horiz" flat dense>
              <edit-cart-menu store-type="stock" />
            </q-btn>
          </q-item-section>
        </q-item>
        <q-item v-if="currentAccount.roles.includes('containerStoreAccess')" >
          <q-item-section avatar>
            <q-icon name="shopping_cart" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Factory Carts </q-item-label>
          </q-item-section>
          <q-item-section side>
            <q-btn class="q-px-none" icon="more_horiz" flat dense>
              <edit-cart-menu store-type="container" />
            </q-btn>
          </q-item-section>
        </q-item>
      </q-expansion-item>
      <q-expansion-item :content-inset-level="0.25" icon="work" label="Contact / T&amp;C" >
        <q-item to="/contact" clickable>
          <q-item-section avatar>
            <q-icon name="alternate_email" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Contact</q-item-label>
          </q-item-section>
        </q-item>
        <q-item to="/terms-and-conditions" clickable>
          <q-item-section avatar>
            <q-icon name="import_contacts" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Terms and Conditions</q-item-label>
          </q-item-section>
        </q-item>
      </q-expansion-item>
      <q-separator inset spaced></q-separator>
      <q-item @click="logout" clickable>
        <q-item-section avatar>
          <q-icon name="logout" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Log Out</q-item-label>
        </q-item-section>
      </q-item>
    </q-btn-dropdown>
  </span>
</template>

<script>
import LoginOpen from "../../views/LoginOpen";
import EditCartMenu from "../../components/EditCartMenu";

export default {
  name: 'AccountAccess',
  props: ['storeType'],
  components: {
    LoginOpen,
    EditCartMenu,
  },  
  data () {
    return {
        details: { cartId: this.getCartID },
        screenMobileSize: false,
        loginIcon:"",
        accountLabel:"",
        activeRetailStyle:"",
        activeStockStyle:"",
        activeContainerStyle:"",
        icon:''
    }
  },
  computed: {
    setActiveStoreStyle(){
        this.activeRetailStyle = (this.storeType == "retail") ? "background-color: #c5161c; color:white; font-weight:bold" : ""
        this.activeStockStyle = (this.storeType == "stock") ? "background-color: #c5161c; color:white; font-weight:bold" : ""
        this.activeContainerStyle = (this.storeType == "container") ? "background-color: #c5161c; color:white; font-weight:bold" : ""
      return true
    },
    sizeWatcher(){
      if(this.$q.screen.width < 920){
        this.loginIcon = ""
        this.accountLabel = ""
      }else{
        this.loginIcon = "person"
        this.accountLabel = "Account"
      }
    },
    currentAccount() {
      return this.$store.state.auth.currentAccount;
    },
    loggedIn() {
      return !!this.currentAccount;
    },
    getCartID() {
      let id;
      if (!!this.currentAccount && this.storeType == 'retail') {
        id  = this.$store.state.auth.currentAccount?.activeRetailCartId;
      }
      else if(!(!!this.currentAccount) && this.storeType == 'retail'){
        id = this.$store.state.auth.currentGuest.activeRetailCartId;
      }
      else if (!!this.currentAccount && this.storeType == 'stock') {
        id = this.$store.state.auth.currentAccount?.activeCartId;
      }
      else if (!!this.currentAccount && this.storeType == 'container') {
        id = this.$store.state.auth.currentAccount?.activeContainerCartId;
      }
      return id;
    },        
  },
  methods: {
    cleanFilter(){
      this.$store.commit('filters/clearFilters')
    },
    getName() {
      return this.currentAccount.contactName;
    },
    getEmail() {
      return this.currentAccount.email;
    },      
    logout() {
      this.$q.dialog({
          title: "Log Out",
          message: `Are you sure you want to log out?`,
          cancel: true,
        })
        .onOk(() => {
          this.$store.dispatch("auth/logout", null);
          // eslint-disable-next-line no-undef
          analytics.track("Logout");
          if (this.$route.path.includes('retail')) {
            this.$router.push("/home").catch(() => {});
          }else{
            this.$router.push("/retail")
          }
        });
    },      
  }
}
</script>

<style scoped lang="stylus">
@import '~quasar-variables';

.loginOpen {
  min-height: 250px; 
  padding-top: 20px;
}

.loginButton{
  @media (min-width: 921px) {
    float: right; 
    padding: 8px 4px;
  }

  @media (max-width: 920px) {
    font-weight: bold; 
    width: 100px; 
    padding-left: 20px;
  }
}

.accountButton {
  @media (min-width: 921px) {
    float: right; 
    padding: 10px 4px;
  }

  @media (max-width: 920px) {
    font-weight: bold;
    width: 100px;
    padding-left: 20px;
  }
}

.detailsBox {
  overflow: hidden; 
  max-width: 260px;
}

.name{
  overflow: hidden; 
  max-width: 260px;
}

.email {
  font-size: 12px;
}

.activeStore{
  color: white
  font-weight: bold
  background: #c5161c
}

</style>